import {
    CONFIG_FIELD_TYPE as SOURCE_CONFIG_FIELD_TYPE,
    NONE_RADIO_OPTION as SOURCE_NONE_RADIO_OPTION
} from 'SourceComponent/ProductCustomizableOption/ProductCustomizableOption.config';

// TODO: implement CONFIG_FIELD_TYPE
export const CONFIG_FIELD_TYPE = {
    ...SOURCE_CONFIG_FIELD_TYPE,
    email: 'email'
};

// TODO: implement CONFIG_FIELD_TYPE
// export const CONFIG_FIELD_TYPE = SOURCE_CONFIG_FIELD_TYPE;

// TODO: implement NONE_RADIO_OPTION
export const NONE_RADIO_OPTION = SOURCE_NONE_RADIO_OPTION;

export default CONFIG_FIELD_TYPE;
